
import React, { ReactNode } from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';

type StatCardProps = {
  title: string;
  value: number;
  icon: ReactNode;
  iconColor?: string;
};

const StatCard = ({ title, value, icon, iconColor = 'text-accent' }: StatCardProps) => {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg font-medium">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-center">
          <div className={`h-8 w-8 ${iconColor} mr-3`}>{icon}</div>
          <span className="text-3xl font-bold">{value}</span>
        </div>
      </CardContent>
    </Card>
  );
};

export default StatCard;
